/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CustomSetup32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path
            d="M11.562 11.149a2.528 2.528 0 00-.866-.813l-.001.001a3.973 3.973 0 00-.695-.35l.153-.057c.242-.104.477-.225.705-.36a2.6 2.6 0 00.838-.889c.123-.22.231-.447.324-.681v.046c.105.268.233.528.38.776.22.354.528.644.896.842.228.123.466.236.704.34l-.229.105a3.811 3.811 0 00-.695.378c-.3.21-.554.48-.742.795a6.88 6.88 0 00-.353.718l-.056-.132a5.018 5.018 0 00-.363-.72zm8.146 1.001a1.607 1.607 0 102.273 2.272l2.59-2.59a4.803 4.803 0 01.426 2.156l.002.137a4.76 4.76 0 01-1.506 3.563 5.2 5.2 0 01-3.577 1.437 4.818 4.818 0 01-1.318-.187l-.69-.188-4.707 4.688a1.825 1.825 0 01-2.636 0 1.696 1.696 0 01-.564-1.313 1.794 1.794 0 01.565-1.312l4.706-4.688-.188-.687a4.74 4.74 0 01-.188-1.313 5.295 5.295 0 011.505-3.687A5.203 5.203 0 0120.092 9h.088c.779 0 1.514.185 2.166.513l-2.637 2.636zM7.577 14.751c.257.15.475.363.634.62.07.119.134.284.193.436.027.069.052.135.077.193.072-.186.156-.367.25-.54.137-.236.32-.44.539-.601.162-.116.338-.214.52-.295l.21-.09a2.01 2.01 0 01-.5-.254 1.812 1.812 0 01-.654-.65 3.162 3.162 0 01-.28-.57 5.957 5.957 0 01-.24.511 1.94 1.94 0 01-.653.64c-.13.077-.324.147-.496.209a6.03 6.03 0 00-.177.066c.199.095.391.204.577.325z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default CustomSetup32;
